import React from "react";

const Button = ({
  variant,
  size,
  type,
  disabled,
  onClick,
  title = "Text",
  color = "",
  className = "",
}) => {
  let classes = `font-semibold rounded inline-block min-w-max transition-all duration-300 ${className} ${color}`;

  switch (variant) {
    case "primary":
      classes += disabled
        ? " bg-gray-400"
        : " bg-blue-600 hover:bg-blue-700 focus:bg-blue-800 text-white shadow-md";
      break;
    case "secondary":
      classes +=
        " border border-gray-300 bg-gray-100 hover:bg-gray-200 focus:bg-gray-300 text-gray-700";
      break;
    case "text":
      classes += " text-blue-600 hover:text-blue-700 focus:text-blue-800";
      break;
    default:
      break;
  }

  switch (size) {
    case "x-small":
      classes += " button-text py-1 px-3";
      break;
    case "small":
      classes += " button-text py-2 px-4";
      break;
    case "medium":
      classes += " text-base py-2 px-4 text-gray-700";
      break;
    case "large":
      classes += " text-lg py-2 px-4 text-gray-700";
      break;
  }

  if (disabled) {
    classes += " opacity-50 cursor-not-allowed";
    onClick = null;
  }

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
    >
      <p>{title}</p>
    </button>
  );
};

export default Button;
